

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import EmailTemplate from '../EmailTemplate';
import toast from "react-hot-toast";
import ReactDOMServer from 'react-dom/server';
import { sentBookFair } from '../../api/api';


export default function Frankfurt2026() {
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        role: '',
        day: 'Wednesday 7 October',
        time: 'Morning (09:00–12:00)',
        topic: 'Accessibility and EAA remediation',
        message: '',
        consent: false,
    });

    const [statusText, setStatusText] = useState('');

    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.company || !formData.email || !formData.consent) {
            setStatusText('* Please complete the required fields above.');
            const invalidEl = e.target.querySelector(':invalid');
            if (invalidEl) invalidEl.focus();
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(formData.email.trim())) {
            setStatusText('* Please enter a valid email address.');

            const emailInput = e.target.querySelector('[name="email"]');
            if (emailInput) emailInput.focus();

            return;
        }
        setLoading(true);

        setStatusText("")


        const htmlString = ReactDOMServer.renderToStaticMarkup(
            <EmailTemplate data={formData} page="book" />
        );

        const formDataToSend = new FormData();
        formDataToSend.append("subject", "Frankfurter Buchmesse 2026 Book Fair Request");
        formDataToSend.append("html", htmlString);
        formDataToSend.append("email", formData.email);

        try {
            const response = await sentBookFair(formDataToSend);

            if (response.data) {

                setFormData({
                    name: '',
                    company: '',
                    email: '',
                    role: '',
                    day: 'Wednesday 7 October',
                    time: 'Morning (09:00–12:00)',
                    topic: 'Accessibility and EAA remediation',
                    message: '',
                    consent: false,
                });
                toast.success("Message sent successfully!");

            } else {
                toast.info(
                    response.error.message + ", Message could not be sent" ||
                    "Failed to send message"
                );

            }
        } catch (err) {
            toast.error("An unexpected error occurred");

        }
        finally {

            setLoading(false);

        }

    };


    return (
        <div className="bg-white text-[#2C3A52] font-['Lato',-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,sans-serif] text-[17px] leading-[1.55] antialiased min-h-screen">
            {/* Skip Link */}
            <a
                href="#main"
                className="absolute -left-[9999px] z-[100] bg-[#0F1A2E] text-white px-[18px] py-[12px] focus:left-3 focus:top-3"
            >
                Skip to main content
            </a>

            {/* Top Accent Bar */}
            <div className="h-[7px] bg-[#FF6600]" role="presentation"></div>

            {/* Header */}
            <header className="border-b border-[#D2DAE6]">
                <div className="max-w-[1180px] mx-auto px-[24px] py-[14px] flex items-center justify-between gap-[16px] flex-wrap">
                    <Link to={"/"}>
                        <img
                            src={process.env.PUBLIC_URL + "/images/transformalogo.svg"}
                            alt="Transforma_logo"
                        />
                    </Link>
                    <a
                        href="#book"
                        className="inline-block font-black text-[#1A1006] bg-[#FF6600] hover:bg-[#E85C00] px-[24px] py-[13px] rounded-[6px] text-[0.98rem] leading-[1.2] no-underline focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                    >
                        Book a meeting
                    </a>
                </div>
            </header>

            {/* Main Content */}
            <main id="main">
                {/* HERO SECTION */}
                <div className="pt-[38px] pb-[30px]">
                    <div className="max-w-[1180px] mx-auto px-[24px]">
                        <div className="grid grid-cols-1 min-[901px]:grid-cols-2 gap-[26px] min-[901px]:gap-[44px] items-center">
                            <div>
                                <p className="font-black tracking-[0.12em] uppercase text-[0.8rem] text-[#C24E00] m-0 mb-[10px]">
                                    Frankfurter Buchmesse 2026
                                </p>
                                <h1 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.25em] font-black text-[clamp(2.1rem,5.2vw,3.5rem)] -tracking-[0.01em]">
                                    <span className="font-light block">AI edits at volume.</span>
                                    <span className="font-black text-[#FF6600] block">
                                        A human decides.
                                    </span>
                                </h1>
                                <p className="text-[1.05rem] max-w-[46ch] m-0 mb-[20px]">
                                    Publishing production since 2002 — 200+ journals and 100+ books a year.
                                    Come and see what our editors keep control of, and what we let the machine do at scale.
                                </p>
                                <div className="flex gap-[12px] flex-wrap">
                                    <a
                                        href="#book"
                                        className="inline-block font-black text-[#1A1006] bg-[#FF6600] hover:bg-[#E85C00] px-[24px] py-[13px] rounded-[6px] text-[0.98rem] leading-[1.2] no-underline focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                    >
                                        Book a meeting or demo
                                    </a>
                                    <a
                                        href="#see"
                                        className="inline-block font-black text-[#0F1A2E] bg-transparent border-2 border-[#D2DAE6] hover:border-[#0F1A2E] px-[22px] py-[11px] rounded-[6px] text-[0.98rem] leading-[1.2] no-underline focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                    >
                                        What we'll show you
                                    </a>
                                </div>
                            </div>

                            <figure className="m-0 rounded-[12px] overflow-hidden border border-[#D2DAE6]">
                                <img
                                    src="/images/bookfair1.png"
                                    alt="Transforma at Frankfurter Buchmesse 2026: AI at speed, human in the loop. Hall 4.1, Stand H61, 7–11 October, Messe Frankfurt."
                                    width="1200"
                                    height="630"
                                    fetchPriority="high"
                                    className="block w-full h-auto"
                                />
                            </figure>
                        </div>
                    </div>
                </div>

                {/* STATS SECTION */}
                <section
                    className="bg-[#0F1A2E] text-white py-[26px]"
                    aria-label="Transforma in numbers"
                >
                    <div className="max-w-[1180px] mx-auto px-[24px]">
                        <div className="grid grid-cols-2 min-[761px]:grid-cols-4 gap-[18px] min-[761px]:gap-[20px]">
                            <div>
                                <p className="m-0 font-black text-[clamp(1.7rem,3.6vw,2.5rem)] text-[#FF6600] leading-none">
                                    2002
                                </p>
                                <p className="m-0 font-black tracking-[0.07em] uppercase text-[0.72rem] mt-[6px] text-white">
                                    Producing since
                                </p>
                                <p className="m-0 text-[#AAB6CA] text-[0.82rem] mt-[1px]">
                                    200+ journals a year
                                </p>
                            </div>
                            <div>
                                <p className="m-0 font-black text-[clamp(1.7rem,3.6vw,2.5rem)] text-[#FF6600] leading-none">
                                    60%
                                </p>
                                <p className="m-0 font-black tracking-[0.07em] uppercase text-[0.72rem] mt-[6px] text-white">
                                    Faster turnaround
                                </p>
                                <p className="m-0 text-[#AAB6CA] text-[0.82rem] mt-[1px]">
                                    with VEDAS
                                </p>
                            </div>
                            <div>
                                <p className="m-0 font-black text-[clamp(1.7rem,3.6vw,2.5rem)] text-[#FF6600] leading-none">
                                    40%
                                </p>
                                <p className="m-0 font-black tracking-[0.07em] uppercase text-[0.72rem] mt-[6px] text-white">
                                    Lower cost
                                </p>
                                <p className="m-0 text-[#AAB6CA] text-[0.82rem] mt-[1px]">
                                    with VEDAS
                                </p>
                            </div>
                            <div>
                                <p className="m-0 font-black text-[clamp(1.7rem,3.6vw,2.5rem)] text-[#FF6600] leading-none">
                                    1M+
                                </p>
                                <p className="m-0 font-black tracking-[0.07em] uppercase text-[0.72rem] mt-[6px] text-white">
                                    Pages remediated
                                </p>
                                <p className="m-0 text-[#AAB6CA] text-[0.82rem] mt-[1px]">
                                    for accessibility
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* FOUR PLATFORMS SECTION */}
                <section id="see" className="py-[40px]">
                    <div className="max-w-[1180px] mx-auto px-[24px]">
                        <p className="font-black tracking-[0.12em] uppercase text-[0.8rem] text-[#C24E00] m-0 mb-[10px]">
                            On the stand
                        </p>
                        <h2 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.4em] font-black text-[clamp(1.4rem,2.8vw,2rem)]">
                            Four things we'll show you
                        </h2>
                        <p className="max-w-[60ch] m-0 mb-0">
                            Twenty minutes each — or bring a live file of your own and we'll run it through, which is
                            usually the more useful version.
                        </p>

                        <div className="grid grid-cols-1 min-[561px]:grid-cols-2 min-[981px]:grid-cols-4 gap-[18px] mt-[20px]">
                            {/* Card Feature */}
                            <div className="border-2 border-[#FF6600] rounded-[11px] p-[20px_18px] bg-[#FFF8F3]">
                                <p className="font-black tracking-[0.09em] uppercase text-[0.66rem] text-[#C24E00] m-0 mb-[7px]">
                                    Accessibility · EAA
                                </p>
                                <h3 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.3em] font-black text-[1.08rem]">
                                    Backlist due June 2030
                                </h3>
                                <ul className="m-0 pl-[1.05em] text-[0.9rem] leading-[1.45] list-disc">
                                    <li className="mb-[5px]">Over 1M pages already remediated</li>
                                    <li className="mb-[5px]">EPUB 3 · EPUB Accessibility 1.1</li>
                                    <li className="mb-[5px]">PDF/UA, tagged structure, MathML</li>
                                    <li className="mb-0">Human-reviewed alt text</li>
                                </ul>
                            </div>

                            {/* Card Standard 1 */}
                            <div className="border-2 border-[#D2DAE6] rounded-[11px] p-[20px_18px] bg-white">
                                <p className="font-black tracking-[0.09em] uppercase text-[0.66rem] text-[#C24E00] m-0 mb-[7px]">
                                    Platform
                                </p>
                                <h3 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.3em] font-black text-[1.08rem]">
                                    VEDAS
                                </h3>
                                <ul className="m-0 pl-[1.05em] text-[0.9rem] leading-[1.45] list-disc">
                                    <li className="mb-[5px]">APA, Vancouver, AMA or your house style</li>
                                    <li className="mb-[5px]">References checked to CrossRef, PubMed</li>
                                    <li className="mb-[5px]">JATS and BITS XML with MathML</li>
                                    <li className="mb-0">Every automated edit logged and visible</li>
                                </ul>
                            </div>

                            {/* Card Standard 2 */}
                            <div className="border-2 border-[#D2DAE6] rounded-[11px] p-[20px_18px] bg-white">
                                <p className="font-black tracking-[0.09em] uppercase text-[0.66rem] text-[#C24E00] m-0 mb-[7px]">
                                    Platform
                                </p>
                                <h3 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.3em] font-black text-[1.08rem]">
                                    EditLaTeX
                                </h3>
                                <ul className="m-0 pl-[1.05em] text-[0.9rem] leading-[1.45] list-disc">
                                    <li className="mb-[5px]">Custom macros and packages resolved</li>
                                    <li className="mb-[5px]">Clean XML with accessible MathML</li>
                                    <li className="mb-[5px]">Every equation checked by a person</li>
                                    <li className="mb-0">Authors, editors and production in one place</li>
                                </ul>
                            </div>

                            {/* Card Standard 3 */}
                            <div className="border-2 border-[#D2DAE6] rounded-[11px] p-[20px_18px] bg-white">
                                <p className="font-black tracking-[0.09em] uppercase text-[0.66rem] text-[#C24E00] m-0 mb-[7px]">
                                    Platform
                                </p>
                                <h3 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.3em] font-black text-[1.08rem]">
                                    Author proofing
                                </h3>
                                <ul className="m-0 pl-[1.05em] text-[0.9rem] leading-[1.45] list-disc">
                                    <li className="mb-[5px]">Browser-based, nothing to install</li>
                                    <li className="mb-[5px]">Queries in context, resolved in one pass</li>
                                    <li className="mb-0">Full audit trail of corrections</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* IMAGE STRIP SECTION */}
                <section className="py-[40px] border-t border-[#D2DAE6]">
                    <div className="max-w-[1180px] mx-auto px-[24px]">
                        <p className="font-black tracking-[0.12em] uppercase text-[0.8rem] text-[#C24E00] m-0 mb-[10px]">
                            The fair
                        </p>
                        <h2 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.2em] font-black text-[clamp(1.4rem,2.8vw,2rem)]">
                            Five days in Hall 4.1
                        </h2>
                        <p className="max-w-[60ch] m-0 mb-0">
                            Around 4,000 exhibitors from over 100 countries. Hall 4.1 is the international B2B floor,
                            where publishers, agents and service providers do the year's business.
                        </p>

                        <div className="grid grid-cols-1 min-[761px]:grid-cols-3 gap-[18px] mt-[18px]">
                            <figure className="m-0 rounded-[11px] overflow-hidden border border-[#D2DAE6] bg-[#F2F5F9]">
                                <img
                                    src="/images/bookfair4.png"
                                    alt="Transforma at Frankfurter Buchmesse 2026: AI at speed, human in the loop. Hall 4.1, Stand H61, 7–11 October, Messe Frankfurt."
                                    width="1200"
                                    height="630"
                                    fetchPriority="high"
                                    className="block w-full h-auto"
                                />
                            </figure>

                            <figure className="m-0 rounded-[11px] overflow-hidden border border-[#D2DAE6] bg-[#F2F5F9]">
                                <img
                                    src="/images/bookfair-3.png"
                                    alt="Transforma at Frankfurter Buchmesse 2026: AI at speed, human in the loop. Hall 4.1, Stand H61, 7–11 October, Messe Frankfurt."
                                    width="1200"
                                    height="630"
                                    fetchPriority="high"
                                    className="block w-full h-full"
                                />
                            </figure>

                            <figure className="m-0 rounded-[11px] overflow-hidden border border-[#D2DAE6] bg-[#F2F5F9]">
                                <img
                                    src="/images/bookfair-2.png"
                                    alt="Transforma at Frankfurter Buchmesse 2026: AI at speed, human in the loop. Hall 4.1, Stand H61, 7–11 October, Messe Frankfurt."
                                    width="1200"
                                    height="630"
                                    fetchPriority="high"
                                    className="block w-full h-auto"
                                />
                            </figure>
                        </div>
                    </div>
                </section>

                {/* BOOKING SECTION */}
                <section id="book" className="py-[40px] border-t border-[#D2DAE6]">
                    <div className="max-w-[1180px] mx-auto px-[24px] grid grid-cols-1 min-[901px]:grid-cols-[0.85fr_1.15fr] gap-[28px] min-[901px]:gap-[40px] items-start">
                        <div>
                            <p className="font-black tracking-[0.12em] uppercase text-[0.8rem] text-[#C24E00] m-0 mb-[10px]">
                                Schedule
                            </p>
                            <h2 className="text-[#0F1A2E] leading-[1.12] m-0 mb-[0.4em] font-black text-[clamp(1.4rem,2.8vw,2rem)]">
                                Book a meeting
                            </h2>
                            <p className="m-0 mb-[0.8em]">
                                Tell us a day and a rough time and we'll confirm the slot. Thirty minutes is plenty.
                                Can't make Frankfurt? Say so and we'll set up a remote demo instead.
                            </p>
                            <h3 className="text-[#0F1A2E] leading-[1.12] mb-[0.3em] font-black text-[1.08rem] mt-[18px]">
                                Who gets the most out of it
                            </h3>
                            <ul className="m-0 mt-[14px] pl-[1.05em] text-[0.95rem] list-disc">
                                <li className="mb-[9px]">
                                    <strong className="text-[#0F1A2E]">Production directors</strong> — carrying a remediation deadline or a turnaround problem.
                                </li>
                                <li className="mb-[9px]">
                                    <strong className="text-[#0F1A2E]">Managing editors</strong> — who need an AI story they can defend to a board.
                                </li>
                                <li className="mb-[9px]">
                                    <strong className="text-[#0F1A2E]">Journals teams</strong> — rising submissions, flat capacity.
                                </li>
                                <li className="mb-0">
                                    <strong className="text-[#0F1A2E]">Anyone with a LaTeX problem.</strong>
                                </li>
                            </ul>
                        </div>

                        {/* FORM */}
                        <form
                            id="meeting-form"
                            noValidate
                            onSubmit={handleSubmit}
                            className="bg-[#F2F5F9] rounded-[12px] p-[24px] border-l-[7px] border-[#FF6600]"
                        >
                            <fieldset className="border-0 p-0 m-0 mb-[14px]">
                                <legend className="font-black text-[#0F1A2E] text-[0.95rem] p-0 mb-[9px]">
                                    About you
                                </legend>
                                <div className="grid grid-cols-1 min-[521px]:grid-cols-2 gap-[12px]">
                                    <div className="mb-[12px]">
                                        <label
                                            htmlFor="name"
                                            className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                        >
                                            Name{' '}
                                            <span className="text-[#C24E00]" aria-hidden="true">
                                                *
                                            </span>
                                            <span className="sr-only">(required)</span>
                                        </label>
                                        <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            autoComplete="name"
                                            required
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                        />
                                    </div>
                                    <div className="mb-[12px]">
                                        <label
                                            htmlFor="company"
                                            className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                        >
                                            Organisation{' '}
                                            <span className="text-[#C24E00]" aria-hidden="true">
                                                *
                                            </span>
                                            <span className="sr-only">(required)</span>
                                        </label>
                                        <input
                                            id="company"
                                            name="company"
                                            type="text"
                                            autoComplete="organization"
                                            required
                                            value={formData.company}
                                            onChange={handleChange}
                                            className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 min-[521px]:grid-cols-2 gap-[12px]">
                                    <div className="mb-[12px]">
                                        <label
                                            htmlFor="email"
                                            className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                        >
                                            Email{' '}
                                            <span className="text-[#C24E00]" aria-hidden="true">
                                                *
                                            </span>
                                            <span className="sr-only">(required)</span>
                                        </label>
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            required
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                        />
                                    </div>
                                    <div className="mb-[12px]">
                                        <label
                                            htmlFor="role"
                                            className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                        >
                                            Role
                                        </label>
                                        <input
                                            id="role"
                                            name="role"
                                            type="text"
                                            autoComplete="organization-title"
                                            value={formData.role}
                                            onChange={handleChange}
                                            className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                        />
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset className="border-0 p-0 m-0 mb-[14px]">
                                <legend className="font-black text-[#0F1A2E] text-[0.95rem] p-0 mb-[9px]">
                                    When and what
                                </legend>
                                <div className="grid grid-cols-1 min-[521px]:grid-cols-2 gap-[12px]">
                                    <div className="mb-[12px]">
                                        <label
                                            htmlFor="day"
                                            className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                        >
                                            Day
                                        </label>
                                        <select
                                            id="day"
                                            name="day"
                                            value={formData.day}
                                            onChange={handleChange}
                                            className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                        >
                                            <option>Wednesday 7 October</option>
                                            <option>Thursday 8 October</option>
                                            <option>Friday 9 October</option>
                                            <option>Saturday 10 October</option>
                                            <option>Sunday 11 October</option>
                                            <option>Any day — you choose</option>
                                            <option>Can't attend — remote demo</option>
                                        </select>
                                    </div>
                                    <div className="mb-[12px]">
                                        <label
                                            htmlFor="time"
                                            className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                        >
                                            Time
                                        </label>
                                        <select
                                            id="time"
                                            name="time"
                                            value={formData.time}
                                            onChange={handleChange}
                                            className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                        >
                                            <option>Morning (09:00–12:00)</option>
                                            <option>Early afternoon (12:00–15:00)</option>
                                            <option>Late afternoon (15:00–18:00)</option>
                                            <option>Flexible</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="mb-[12px]">
                                    <label
                                        htmlFor="topic"
                                        className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                    >
                                        Topic
                                    </label>
                                    <select
                                        id="topic"
                                        name="topic"
                                        value={formData.topic}
                                        onChange={handleChange}
                                        className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                    >
                                        <option>Accessibility and EAA remediation</option>
                                        <option>VEDAS — copy editing</option>
                                        <option>EditLaTeX — LaTeX to XML</option>
                                        <option>Author proofing platform</option>
                                        <option>End-to-end journal production</option>
                                        <option>Book production</option>
                                        <option>Translation</option>
                                        <option>Something else</option>
                                    </select>
                                </div>

                                <div className="mb-[12px]">
                                    <label
                                        htmlFor="message"
                                        className="block font-bold text-[#0F1A2E] text-[0.85rem] mb-[4px]"
                                    >
                                        Anything we should prepare?
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        placeholder="A file type, a journal, a deadline you're working to."
                                        value={formData.message}
                                        onChange={handleChange}
                                        className="w-full text-[0.95rem] p-[10px_12px] border-2 border-[#D2DAE6] rounded-[6px] bg-white text-[#0F1A2E] min-h-[76px] resize-y focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                    ></textarea>
                                    <p className="text-[0.8rem] text-[#5C6B84] m-0 mt-[5px]">
                                        Tell us the format and we'll have a live sample ready.
                                    </p>
                                </div>
                            </fieldset>

                            <div className="flex gap-[9px] items-start mb-[12px]">
                                <input
                                    id="consent"
                                    name="consent"
                                    type="checkbox"
                                    required
                                    checked={formData.consent}
                                    onChange={handleChange}
                                    className="w-auto mt-[3px] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                />
                                <label
                                    htmlFor="consent"
                                    className="font-normal text-[0.85rem] text-[#0F1A2E] m-0"
                                >
                                    I'm happy for Transforma to contact me about this request.{' '}
                                    <span className="text-[#C24E00]" aria-hidden="true">
                                        *
                                    </span>
                                </label>
                            </div>

                            <button
                                disabled={loading}
                                type="submit"
                                className="w-full disabled:opacity-50 disabled:cursor-not-allowed inline-block font-black text-[#1A1006] bg-[#FF6600] hover:bg-[#E85C00] px-[24px] py-[13px] rounded-[6px] text-[0.98rem] leading-[1.2] border-0 cursor-pointer font-inherit focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                            >
                                {loading ? "processing..." : "Request this slot"}
                            </button>

                            <p
                                id="form-status"
                                role="status"
                                aria-live="polite"
                                className={`text-[0.8rem]  m-0 mt-[5px] ${statusText ? "text-red-500" : "text-[#5C6B84]"}`}
                            >
                                {statusText ? (
                                    statusText
                                ) : (
                                    <>
                                        Or email{' '}
                                        <a
                                            href="mailto:enquiry@transforma.in"
                                            className="text-[#C24E00] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                                        >
                                            enquiry@transforma.in
                                        </a>
                                        .
                                    </>
                                )}
                            </p>
                        </form>
                    </div>
                </section>
            </main>

            {/* FOOTER */}
            <footer className="bg-[#0F1A2E] text-[#C6D0E0] py-[28px] text-[0.9rem]">
                <div className="max-w-[1180px] mx-auto px-[24px] flex justify-between gap-[20px] flex-wrap items-center">
                    <div>
                        <p className="m-0 font-black text-white text-[1rem]">
                            Transforma Pvt Ltd
                        </p>
                        <p className="m-0">Journals · Books · Accessibility · Translation</p>
                    </div>
                    <div>
                        <p className="m-0">
                            <strong className="text-white">Hall 4.1, Stand H61</strong> · 7–11
                            October 2026
                        </p>
                        <p className="m-0">
                            <a
                                href="mailto:enquiry@transforma.in"
                                className="text-[#FF6600] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-[#C24E00] focus-visible:ring-offset-3"
                            >
                                enquiry@transforma.in
                            </a>
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
}